import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import moment from "moment";
import 'moment-timezone';

import Card from "./bootstrap/Card";
import CardHeader from "./bootstrap/CardHeader";
import CardBlock from "./bootstrap/CardBlock";
import { INSTRUCTOR, STUDENT } from '../constants/roles';
import { Link } from "react-router";
import { spaceToUnderscore } from "../helpers/helpers";

const timezone = 'America/New_York';

class ProfileArea extends Component {
    constructor(props) {
        super(props);
    }

    getDaysLate(assignment, submitted) {
        if (moment(assignment.due_date) < moment(submitted)) {
            let late = moment(submitted).diff(moment(assignment.due_date), 'seconds');
            let duration = moment.duration(late, 'seconds');

            return duration.humanize() + ' late';
        }

        return '';
    }

    renderAssignmentsTable() {
        const { assignments, dropbox, memberships, submissions, user } = this.props,
            dropbox_assignments = _.filter(
                assignments,
                assignment => {
                    return assignment.dropbox.id === dropbox.id;
                }
            )
        ;

        return (
            <CardBlock>
                <table className="table course-list">
                    <thead>
                    <tr className="course-list-header">
                        <th>Assignment</th>
                        <th>Submitted</th>
                        <th>Checked Submission</th>
                        <th>Late</th>
                        <th>Not Done</th>
                        <th>Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        _.map(
                            dropbox_assignments,
                            assignment => {
                                let not_done = _.filter(
                                        memberships,
                                        (membership) => {
                                            if (membership === memberships.dropbox || membership === memberships.user) {
                                                return false;
                                            }
                                            const submission = submissions[membership.submission.id];
                                            return membership.confirmed &&
                                                submission &&
                                                submission.assignment.id === assignment.id &&
                                                submission.not_done
                                            ;
                                        }
                                    ).length > 0,
                                    submission = _.first(
                                        _.filter(
                                            submissions,
                                            submission => {
                                                if (submission === submissions.dropbox || submission === submissions.user) {
                                                    return false;
                                                }
                                                const confirmed = _.size(
                                                    _.filter(
                                                        memberships,
                                                        membership => {
                                                            return membership.confirmed && membership.submission.id === submission.id;
                                                        }
                                                    )
                                                ) > 0;

                                                return confirmed &&
                                                    submission &&
                                                    submission.assignment.id === assignment.id &&
                                                    submission.updated
                                                ;
                                            }
                                        )
                                    ),
                                    submitted = submission
                                    ?
                                        _.pick(
                                            _.last(
                                                _.sortBy(
                                                    submission.submission_files,
                                                    (submission_file) => {
                                                    return moment(submission_file.updated);
                                                    }
                                                )
                                            ),
                                            'updated'
                                        ).updated
                                    : null,
                                    late_assignment = _.filter(
                                        memberships,
                                        (membership) => {
                                            if (membership === memberships.dropbox || membership === memberships.user) {
                                                return false;
                                            }

                                            const submission = submissions[membership.submission.id];

                                            return membership.confirmed &&
                                                submission &&
                                                submission.assignment.id === assignment.id &&
                                                submitted &&
                                                moment(submitted).isAfter(moment(assignment.due_date))
                                            ;
                                        }
                                    ).length > 0
                                ;

                                return (
                                    <tr key={`assignment_${assignment.id}`}>
                                        <td>
                                            {
                                                submitted
                                                ?
                                                    <Link
                                                        to={`/dropboxes/${dropbox.id}/users/${user.id}/assignments/${assignment.id}`}
                                                        onlyActiveOnIndex={false}
                                                    >
                                                        {assignment.name}
                                                    </Link>
                                                : assignment.name
                                            }
                                        </td>
                                        <td>
                                            {
                                                submitted
                                                ? moment(submitted).tz(timezone).format('MM-DD-YYYY h:mm:ss a')
                                                : <i className="fa fa-minus disabled" aria-hidden="true" />
                                            }
                                        </td>
                                        <td>
                                            {
                                                submission
                                                ? submission.attempts
                                                : 0
                                            } of {
                                                assignment.submission_attempts_max < 1
                                                ? "unlimited"
                                                : assignment.submission_attempts_max
                                            }
                                        </td>
                                        {
                                            late_assignment
                                            ?
                                                <td style={{textAlign:"left"}}>
                                                    <i className="fa fa-calendar-check-o assignment-red" aria-hidden="true"> {this.getDaysLate(assignment, submitted)}</i>
                                                </td>
                                            :
                                                <td>
                                                    <i className="fa fa-minus disabled" aria-hidden="true" />
                                                </td>
                                        }
                                        <td>
                                            {
                                                not_done
                                                    ? <i className="fa fa-check-circle-o assignment-red" aria-hidden="true" />
                                                    : <i className="fa fa-minus disabled" aria-hidden="true" />
                                            }
                                        </td>
                                        <td>
                                            {
                                                assignment.group_submission
                                                ? (
                                                    <span>
                                                        <Link
                                                            to={`/${dropbox.name}/${spaceToUnderscore(assignment.name)}/groups`}
                                                            onlyActiveOnIndex={false}
                                                        >
                                                            <i
                                                                title="Group Assignment"
                                                                className="fa fa-users"
                                                                aria-hidden="true"
                                                            />
                                                        </Link>
                                                    </span>
                                                ) : (
                                                    <i
                                                        title="Individual Assignment"
                                                        className="fa fa-user"
                                                        aria-hidden="true"
                                                    />
                                                )
                                            }
                                        </td>
                                    </tr>
                                );
                            }
                        )
                    }
                    </tbody>
                </table>
                <span className="table-rounded-bottom" />
            </CardBlock>
        );
    }

    render () {
        const { roles, user } = this.props,
            precept = _.pick(
                _.first(
                    _.filter(
                        roles,
                        (dropbox_role) => {
                            return dropbox_role.role === STUDENT && user.id === dropbox_role.user.id;
                        }
                    )
                ),
                ['precept']
            ).precept,
            subscriptions = _.pick(
                _.first(
                    _.filter(
                        roles,
                        (dropbox_role) => {
                            return dropbox_role.role === INSTRUCTOR && user.id === dropbox_role.user.id;
                        }
                    )
                ),
                ['subscriptions']
            ).subscriptions,
            hasInstructorRole = _.includes(
                _.flatMap(
                    _.filter(
                        roles,
                        (dropbox_role) => {
                            return user.id === dropbox_role.user.id;
                        }
                    ),
                    (dropbox_role) => {
                        return dropbox_role.role;
                    }),
                INSTRUCTOR
            ),
            subscription_labels = {
                "not_done_email": "Not Done Email",
                "late_assignment_email": "Late Assignment Email",
                "leave_group_email": "Leave Group Email",
                "empty_group_email": " Empty Group Email",
            }
        ;

        return roles && user ?
        (
            <Card>
                <CardHeader className="bg-primary">{user.username}</CardHeader>
                <CardBlock>
                    <ul>
                        <li>Email Address: {user.email}</li>
                        <li>Name: {user.first_name} {user.last_name}</li>
                    </ul>
                    <hr/>
                    {
                        hasInstructorRole
                            ? (
                                <ul>
                                    <li>
                                        Subscriptions:&nbsp;
                                        {
                                            _.size(subscriptions) > 0
                                            ?
                                                _.map(
                                                    subscriptions,
                                                    (subscription) => {
                                                        return (
                                                            <span key={`subscription_${subscription.type}`} className="subscriptions">
                                                                ({subscription_labels[subscription.type]})&nbsp;
                                                            </span>
                                                        );
                                                    }
                                                )
                                            : 'None'
                                        }
                                    </li>
                                </ul>
                            ) : (
                                <div>
                                    <ul>
                                        <li>Precept : {precept}</li>
                                    </ul>
                                    <hr/>
                                    <ul>
                                        <Card>
                                            <CardHeader>Assignments</CardHeader>
                                            {this.renderAssignmentsTable()}
                                        </Card>
                                    </ul>
                                </div>
                            )
                    }
                </CardBlock>
            </Card>
        ) :
            null
        ;
    }
}

ProfileArea.propTypes = {
    assignments: PropTypes.object.isRequired,
    dropbox: PropTypes.object.isRequired,
    memberships: PropTypes.object.isRequired,
    roles: PropTypes.object.isRequired,
    submissions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

export default ProfileArea;



/** WEBPACK FOOTER **
 ** ./src/components/ProfileArea.js
 **/